import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换时滚动到顶部（不影响现有的“回到顶部”浮动按钮）
 */
export default function RouteScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // 如果带 hash（锚点）则交给浏览器默认行为/业务逻辑处理
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return null;
}

